import Navigation from "./navigation";
import React from "react";
import './App.css';
import { Toaster } from "react-hot-toast";
import AutoLogout from "./AutoLogout";
import { useState, useEffect } from 'react';
import WebService from "./utility/WebService";

const App = () => {

  useEffect(() => {
    //document.title = "Dynamic Title Example";
    getCompanyDetail();
   
  }, []);

  const getCompanyDetail = () => {
    WebService.getAPI({
      action: `/CompanyMaster/CompanyDetail`,
    })
      .then((res: any) => {
        if(res){
          if(res.short_name	){
            document.title = res.short_name	;
          const newLink = document.createElement('link');
          newLink.rel = 'icon';
          newLink.href = res.image_path	;
          document.head.appendChild(newLink);
          }
        }
      })
      .catch((e) => {
        //
      });
  };

  return (
    <>

      <div className=" ">
        <div>
          <Toaster
            position="top-right"
            reverseOrder={false}
          /></div>
      </div>
      <AutoLogout />
      <Navigation />
    </>
  )
}

export default App;
